module.exports = __webpack_public_path__ + "static/media/car wash.2556d96f.png";